export function Terms() {
  return (
    <article className="legal-body">
      <h1>Användarvillkor</h1>
      <p className="updated">Senast uppdaterad: 2026-04-14</p>

      <h2>1. Om tjänsten</h2>
      <p>
        Partikampen är ett underhållningsspel. Spelet är <strong>inte anslutet till, godkänt av eller kopplat till något politiskt parti</strong>. Partiernas namn och färger används för att representera lagsida i spelet.
      </p>

      <h2>2. Acceptabel användning</h2>
      <p>Du förbinder dig att inte:</p>
      <ul>
        <li>Försöka manipulera spelet (falska GPS-positioner, automatiserade klick, reverse engineering av våra API:er)</li>
        <li>Använda tjänsten för att trakassera andra användare</li>
        <li>Försöka få obehörig åtkomst till vår backend eller andra användares konton</li>
      </ul>

      <h2>3. Data och integritet</h2>
      <p>
        Vilka uppgifter vi hanterar beskrivs i vår <a href="/privacy-policy">integritetspolicy</a>.
      </p>

      <h2>4. In-app-köp</h2>
      <p>
        Spelet kan innehålla frivilliga köp av spelvaluta. Köp hanteras av Apple App Store respektive Google Play och följer deras villkor. Spelvaluta har inget monetärt värde och kan inte växlas tillbaka.
      </p>

      <h2>5. Inga garantier</h2>
      <p>
        Tjänsten tillhandahålls "i befintligt skick". Vi gör vårt bästa för att hålla spelet tillgängligt men kan inte garantera oavbruten drift. Vi förbehåller oss rätten att ändra spelmekanik, uppdatera eller stänga av tjänsten.
      </p>

      <h2>6. Ändringar</h2>
      <p>
        Vi kan uppdatera dessa villkor. Väsentliga ändringar meddelas i appen eller via datum-uppdateringen överst på denna sida.
      </p>

      <h2>7. Kontakt</h2>
      <p>
        Frågor: <a href="mailto:kontakt@partikampen.se">kontakt@partikampen.se</a>
      </p>

      <h2>8. Distriktsdata</h2>
      <p>
        Kommunvalkretsarnas gränser och befolkningsuppgifter kommer från Valmyndigheten (val.se) och används i enlighet med deras villkor för öppna data.
      </p>
    </article>
  );
}
